import { useEffect } from "react";

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  jsonLd?: object[];
}

function setMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setJsonLd(data: object[]) {
  document.querySelectorAll('script[data-seo-jsonld]').forEach((n) => n.remove());
  data.forEach((obj) => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.dataset.seoJsonld = "true";
    script.textContent = JSON.stringify(obj);
    document.head.appendChild(script);
  });
}

export default function Seo({ title, description, keywords, canonical, jsonLd }: SeoProps) {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    if (keywords) setMeta("name", "keywords", keywords);
    if (canonical) {
      let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical || window.location.href);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    if (jsonLd) setJsonLd(jsonLd);
  }, [title, description, keywords, canonical, jsonLd]);

  return null;
}

export const SITE_URL = "https://stripline1.github.io";